import { Box, Button, useDisclosure, Slide, Heading, Flex, Spacer, Text, InputGroup, InputLeftElement, Input, Divider, IconButton, InputRightElement, Modal, ModalContent, ModalHeader, ModalBody, useMediaQuery, CircularProgress, Image, Checkbox, Link, ModalOverlay, ModalFooter, ModalCloseButton, UnorderedList, ListItem } from '@chakra-ui/react';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useLocation, useNavigate } from 'react-router';
import { useEffect, useState, useRef } from 'react';
import moment from 'moment-timezone';
import { encode } from 'js-base64';

// Icons
import { IconCheck, IconError, IconInfo, IconPhone, VectorDuplicidad, VectorError, VectorSuccess } from '../../Assets/GENERALES/Icons';
import { AiOutlineClose } from "react-icons/ai";

// Components
import { postData, postDataGenesys, postEmail, updateData } from '../../Services/api';
import enviroments from '../../Services/enviroments';

// Images
import bannerHogar from '../../Assets/HOGAR/banner_intermedia.webp';

const SlideModal = ({ setOpenSlideModal, openSlideModal, id, intermedia, submitInitial, plan, price, view, seccion, priceTyc, segmentoInitial, descuento, valuePhoneInitial, setValuePhoneInitial, setColorBorderInitial, setViewIconRightInitial, positionEquipo, linkRedirect, messageButton = 'Quiero que me llamen', seccionSelected, typePlanSelected, typePlan, namePlan, acceptedComunicacion, acceptedtyt }) => {
    const [responseApi, setResponseApi] = useState({mensaje: '', status: ''});
    const [valuePhone, setValuephone] = useState(valuePhoneInitial);
    const [disabledButton, setDisabledButton] = useState(true);
    const [colorBorder, setColorBorder] = useState('#002eff');
    const [loadingRetry, setLoadingRetry] = useState(false);
    const [viewIconRight, setViewIconRight] = useState('');
    const [colorLabel, setColorLabel] = useState('black');
    const [duplicidad, setDuplicidad] = useState(false);
    const [textError, setTextError] = useState(false);
    const [valueName, setValueName] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(true);
    const [tryAgain, setTryAgain] = useState(0);
    const [info, setInfo] = useState(true);

    const { isOpen: isOpenToggle, onToggle } = useDisclosure();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOpenTerms, onOpen: onOpenTerms, onClose: onCloseTerms } = useDisclosure();
    const { isOpen: isOpenComunicaciones, onOpen: onOpenComunicaciones, onClose: onCloseComunicaciones } = useDisclosure();

    const [accepted, setAccepted] = useState(true);
    const [acceptedComunicaciones, setAcceptedComunicaciones] = useState(true);

    const { executeRecaptcha } = useGoogleReCaptcha();

    const [isMobile] = useMediaQuery("(max-width: 768px)");

    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let location = useLocation();
    let navigate = useNavigate();

    const buttonRef = useRef(false);

    let campaignid = urlParams.get('campaignid');
    let seccionParam = urlParams.get("seccion");
    let adgroupid = urlParams.get('adgroupid');
    let anuncioGroup = urlParams.get('group');
    let keyword = urlParams.get('keyword');
    let origin = urlParams.get('origin');
    let gclid = urlParams.get('gclid');
    let adId = urlParams.get('adId');
    let type = urlParams.get('type');

    let exprecionRegular = /^\+?\d*$/;
    
    useEffect(() => {
        submitInitial && handleSubmitLead({retry:false});

        if (intermedia) {
            if (seccion === 'Hogar') {
                window.dataLayer.push({
                    'event': 'GARDNIevent',
                    'eventCategory': `entel ofertas - ${linkRedirect ? 'flujo digital' : 'c2c'} lo quiero`,
                    'eventAction': 'info',
                    'eventLabel': 'carga',
                    'origen': 'entel',
                    'segmento': 'hh',
                    'mercado': 'pe',
                    'page_owner': 'publico',
                    'page_type': 'registro',
                    'form_name': 'te ayudamos a contratar',
                    'form_step_name': 'paso 1-te ayudamos a contratar-nuevo cliente',
                    'form_type': linkRedirect ? 'flujo digital' : 'c2c',
                    'journey_type': 'solicitud',
                    'journey_name': 'hogar',
                    'eventPlan': typePlanSelected === 'duo' ? `duo fibra ${typePlan.toLowerCase()}` : `fibra ${plan?.toLowerCase()}`,
                    'price': price?.replace(/[$.]/g, ''),
                    'plan_subprice': priceTyc?.replace(/[$.]/g, ''),
                    'type_offer': descuento?.replace('%', 'porciento dcto'),
                    'visitor_type': 'nuevo cliente',
                })
            } else {
                window.dataLayer.push({
                    event: 'GARDNIevent',
                    eventCategory: 'planes - c2c lo quiero',
                    eventAction: 'info',
                    eventLabel: 'carga',
                    origen: 'entel',
                    mercado: 'pe',
                    segmento: 'po',
                    product_name: plan.toLowerCase(),
                    product_quantity: '1',
                    product_price: price?.replace(/[$.]/g, ''),
                    product_subprice: priceTyc?.replace(/[$.]/g, ''),
                    form_step_name: `paso 1 - estas solicitando plan ${plan.toLowerCase()}`,
                    form_type: "c2c",
                    journey_name : `plan ${seccionSelected}`,
                    journey_type: 'solicitud',
                    page_owner: 'movil',
                    page_category: 'landing-comercial'
                });
            }
        }
    }, []);

    useEffect(() => {
        isMobile ? onToggle() : onOpen();
    }, [isMobile]);
    
    const handleChangeInput = (value) => {
        if (value.startsWith("+56") && exprecionRegular.test(value)) {
            setValuephone(value);
            if (value.length > 13 || value.length < 13 || value.length !== 4) {
                setViewIconRight('Error');
                setColorBorder('#DB110A');
                setDisabledButton(true);
                setTextError(true);
            } if (value.length === 12) {
                setViewIconRight('Success');
                setColorBorder('#1EA67B');
                if (valueName !== '' && accepted) {
                    setDisabledButton(false);
                }
                setTextError(false);
            } if (value.length === 4) {
                setColorBorder('#002eff');
                setDisabledButton(true);
                setViewIconRight('');
                setTextError(false);
            }
        }
    };

    const handleAcceptedChange = (e) => {
        const value = e.target.checked;
        setAccepted(value);
        if (valuePhone.length === 12 && valueName.length > 0 && value) {
            setDisabledButton(false);
        } else {
            setDisabledButton(true);
        }
    };

    const submitLead = async (endpointSave, journey_name, segmento, countAgain, campaignid, adgroupid, keyword, adId, referer) => {
        if (!executeRecaptcha) {
            alert("Error: No se pudo cargar reCAPTCHA.");
            return;
        }

        const submit = await postData(endpointSave, {
            name: valueName === '' ? 'form' : valueName, 
            phone: parseInt(valuePhone.replace('+56', '')), 
            plan, 
            gclid, 
            anuncioGroup, 
            id_lead: '', 
            dominio: `entel-ofertas.cl${location.pathname}${linkRedirect ? '-online' : ''}`, 
            view: location.pathname, 
            error: '', 
            origin,
            campaignid, 
            adgroupid, 
            keyword, 
            insertGenesys: 'Primera inserción',
            adId,
            acceptedComunicacion: acceptedComunicacion !== undefined ? acceptedComunicacion ? 'Si' : 'No' : acceptedComunicaciones ? 'Si' : 'No',
            acceptedtyt: acceptedtyt !== undefined ? acceptedtyt ? 'Si' : 'No' : accepted ? 'Si' : 'No',
            type,
            referer,
            direct: false,
            url: window.location.href
        });

        if (submit?.catch) {
            if (countAgain === 3) {
                window.dataLayer.push({
                    event: 'GARDNIevent',
                    eventCategory: 'planes - c2c lo quiero - conversion',
                    eventAction: 'info',
                    eventLabel: 'carga',
                    origen: 'entel',
                    mercado: 'pe',
                    segmento: 'po',
                    status: "error",
                    product_name: plan.toLowerCase(),
                    product_quantity: '1',
                    product_price: price?.replace(/[$.]/g, ''),
                    product_subprice: priceTyc?.replace(/[$.]/g, ''),
                    form_step_name: `paso 2 - estas solicitando plan ${plan?.toLowerCase()}`,
                    phone_client: encode(valuePhone),
                    form_type: "c2c",
                    journey_name : `plan ${seccionSelected}`,
                    journey_type: 'solicitud',
                    page_owner: 'movil',
                    page_category: 'landing-comercial',
                    variant_1: "servicio no disponible"
                })

                await postEmail('emails', {
                    telefono_cliente: parseInt(valuePhone.replace('+56', '')),
                    nombre_cliente: valueName === '' ? 'form' : valueName,
                    tipo_lead: plan,
                    gclid: gclid,
                    origin,
                    fecha: moment().format("DD-MM-YYYY hh:mm a"),
                    error: `${submit?.error} ---------- ${submit?.data} -------- ${submit?.error2}`,
                    landing: "entel",
                });

                setInfo(false);
                setLoading(false);
                setSuccess(false);
                setDuplicidad(false);
                setLoadingRetry(false);
                if (linkRedirect) {
                    window.open(linkRedirect, '_blank');
                }
                buttonRef.current = true;
                return true;
            } else {
                return false;
            }
        } else {
            if (submit?.OK === true) {
                if (view === 'equipos' || view === 'ofertas') {
                    let objDl = {
                        'event': 'GARDNIevent',
                        'eventCategory': 'entel ofertas - c2c - conversion',
                        'eventAction': 'info',
                        'eventLabel': 'carga',
                        'origen': 'entel',
                        'segmento': segmento !== '' ? segmento : segmentoInitial,
                        'mercado': 'pe',
                        'page_owner': 'publico',
                        'form_type': 'c2c',
                        'journey_type': 'solicitud',
                        'journey_name': view,
                        'nombre': encode(valueName.toLowerCase()),
                        'telefono_cliente': encode(valuePhone),
                        'visitor_type': 'nuevo cliente',
                        'page_type': submit?.STATUS_INSERT,
                        'social_media_id': encode(`${valuePhone.replace('+', '')}${moment().tz("America/Santiago").unix()}`)
                    }

                    if (seccion === 'movil') {
                        objDl['variant'] = 'formulario card ofertas movil';
                    } else if (seccion === 'hogar') {
                        objDl['variant'] = 'formulario card ofertas hogar';
                    } else if (view === 'equipos') {
                        objDl['variant'] = `formulario card equipo`;
                        objDl['position'] = positionEquipo;
                    } else {
                        objDl['variant'] = `formulario card ofertas ${seccion}`;
                    }

                    window.dataLayer.push(objDl)
                } if (view === 'plan') {
                    if (seccion === 'Hogar' || seccion === 'Movil') {
                        if (seccion === 'Movil') {
                            setResponseApi({mensaje: 'Recibimos tu solicitud', status: 'exito'});
                            window.dataLayer.push({
                                event: 'GARDNIevent',
                                eventCategory: 'planes - c2c lo quiero - conversion',
                                eventAction: 'info',
                                eventLabel: 'carga',
                                origen: 'entel',
                                mercado: 'pe',
                                segmento: 'po',
                                status: "exito",
                                product_name: plan.toLowerCase(),
                                product_quantity: '1',
                                product_price: price.replace(/[$.]/g, ''),
                                product_subprice: priceTyc.replace(/[$.]/g, ''),
                                form_step_name: `paso 2 - estas solicitando plan ${plan.toLowerCase()}`,
                                phone_client: encode(valuePhone),
                                form_type: "c2c",
                                journey_name: typePlanSelected === 'portabilidad' ? `plan portabilidad` : `plan linea nueva`,
                                journey_type: 'solicitud',
                                page_owner: 'movil',
                                page_category: 'landing-comercial',
                                variant_1: "Recibimos tu solicitud",
                                social_media_id: encode(`${valuePhone.replace('+', '')}${moment().tz("America/Santiago").unix()}`)
                            })
                        } else {
                            window.dataLayer.push({
                                'event': 'GARDNIevent',
                                'eventCategory': seccion === 'Hogar' ? `entel hogar - ${linkRedirect ? 'flujo digital' : 'c2c'} lo quiero - conversion` : seccion === 'Movil' && `entel ofertas - movil - ${linkRedirect ? 'flujo digital' : 'c2c'} planes conversion`,
                                'eventAction': 'info',
                                'eventLabel': 'carga',
                                'origen': 'entel',
                                'segmento': seccion === 'Hogar' ? 'hh' : 'po',
                                'mercado': 'pe',
                                'page_owner': 'publico',
                                'page_type': submit?.STATUS_INSERT,
                                'form_name': 'Te ayudamos a contratar',
                                'form_step_name': 'paso 2 - recibimos tu solicitud - nuevo cliente',
                                'form_type': linkRedirect ? 'flujo digital' : 'c2c',
                                'journey_type': 'solicitud',
                                'journey_name': seccion === 'Hogar' ? 'hogar' : 'movil',
                                'nombre': encode(valueName.toLowerCase()),
                                'telefono_cliente': encode(valuePhone),
                                'eventPlan': seccion === 'Hogar' 
                                    ? typePlanSelected === 'duo' 
                                        ? `duo pack ${namePlan.replace('+', '').toLowerCase()}` 
                                        : `${namePlan?.toLowerCase()}`
                                    : plan.toLowerCase(),
                                'price': price.replace(/[$.]/g, ''),
                                'plan_subprice': priceTyc.replace(/[$.]/g, ''),
                                'type_offer': descuento.replace('%', 'porciento dcto'),
                                'visitor_type': 'nuevo cliente',
                                'social_media_id': encode(`${valuePhone.replace('+', '')}${moment().tz("America/Santiago").unix()}`)
                            })
                        }
                    } else {
                        window.dataLayer.push({
                            'event': 'GARDNIevent',
                            'eventCategory': 'entel ofertas - c2c lo quiero - conversion',
                            'eventAction': 'info',
                            'eventLabel': 'carga',
                            'origen': 'entel',
                            'segmento': segmento,
                            'mercado': 'pe',
                            'page_owner': 'publico',
                            'form_type': 'c2c',
                            'journey_type': 'solicitud',
                            'journey_name': 'movil',
                            'eventPlan': plan.toLowerCase(),
                            'price': price.replace(/[$.]/g, ''),
                            'plan_subprice': priceTyc.replace(/[$.]/g, ''),
                            'type_offer': descuento.replace('%', 'porciento dcto'),
                            'nombre': encode(valueName.toLowerCase()),
                            'telefono_cliente': encode(valuePhone),
                            'visitor_type': 'nuevo cliente',
                            'page_type': submit?.STATUS_INSERT,
                            'social_media_id': encode(`${valuePhone.replace('+', '')}${moment().tz("America/Santiago").unix()}`)
                        })
                    }
                } if (view === 'navbar') {
                    window.dataLayer.push({
                        'event': 'GARDNIevent',
                        'eventCategory': 'entel ofertas - c2c conversion',
                        'eventAction': 'info',
                        'eventLabel': 'carga',
                        'origen': 'entel',
                        'segmento': segmento,
                        'mercado': 'pe',
                        'page_owner': 'publico',
                        'form_type': 'c2c',
                        'journey_type': 'solicitud',
                        'journey_name': journey_name,
                        'nombre': encode(valueName.toLowerCase()),
                        'telefono_cliente': encode(valuePhone),
                        'visitor_type': 'nuevo cliente',
                        'page_type': submit?.STATUS_INSERT,
                        'variant': 'formulario header',
                        'social_media_id': encode(`${valuePhone.replace('+', '')}${moment().tz("America/Santiago").unix()}`)
                    });
                } if (view === 'formulario_directo') {
                    window.dataLayer.push({
                        'event': 'GARDNIevent',
                        'eventCategory': `${view === 'equipos' ? 'ecommerce ' : ''}entel ofertas - c2c directo - conversion`,
                        'eventAction': 'info',
                        'eventLabel': 'carga',
                        'origen': 'entel',
                        'segmento': segmento,
                        'mercado': 'pe',
                        'page_owner': 'publico',
                        'form_type': 'c2c',
                        'journey_type': 'solicitud',
                        'journey_name': journey_name,
                        'telefono_cliente': encode(valuePhone),
                        'visitor_type': 'nuevo cliente',
                        'page_type': submit?.STATUS_INSERT,
                        'variant': 'c2c directo inferior',
                        'social_media_id': encode(`${valuePhone.replace('+', '')}${moment().tz("America/Santiago").unix()}`)
                    })
                } if (view === 'banner') {
                    window.dataLayer.push({
                        'event': 'GARDNIevent',
                        'eventCategory': `${view === 'equipos' ? 'ecommerce ' : ''}entel ofertas - banner principal c2c - conversion`,
                        'eventAction': 'info',
                        'eventLabel': 'carga',
                        'origen': 'entel',
                        'segmento': segmento,
                        'mercado': 'pe',
                        'page_owner': 'publico',
                        'journey_type': 'solicitud',
                        'nombre': encode(valueName.toLowerCase()),
                        'telefono_cliente': encode(valuePhone),
                        'visitor_type': 'nuevo cliente',
                        'variant': typePlanSelected === 'duo' ? `formulario banner principal hogar duo` : `formulario banner principal ${journey_name}`,
                        'page_type': submit?.STATUS_INSERT,
                        'social_media_id': encode(`${valuePhone.replace('+', '')}${moment().tz("America/Santiago").unix()}`)
                    })
                };

                if (submit?.STATUS_INSERT === 'error') {
                    if (countAgain === 3) {
                        if (seccionSelected) {
                            setResponseApi({mensaje: 'servicio no disponible', status: 'error'});
                            window.dataLayer.push({
                                event: 'GARDNIevent',
                                eventCategory: 'planes - c2c lo quiero - conversion',
                                eventAction: 'info',
                                eventLabel: 'carga',
                                origen: 'entel',
                                mercado: 'pe',
                                segmento: 'po',
                                status: "error",
                                product_name: plan.toLowerCase(),
                                product_quantity: '1',
                                product_price: price.replace(/[$.]/g, ''),
                                product_subprice: priceTyc.replace(/[$.]/g, ''),
                                form_step_name: `paso 2 - estas solicitando plan ${plan.toLowerCase()}`,
                                phone_client: encode(valuePhone),
                                form_type: "c2c",
                                journey_name : `plan ${seccionSelected}`,
                                journey_type: 'solicitud',
                                page_owner: 'movil',
                                page_category: 'landing-comercial',
                                variant_1: "servicio no disponible"
                            })
                        }

                        await postEmail('emails', {
                            telefono_cliente: valuePhone,
                            nombre_cliente: valueName === '' ? 'form' : valueName,
                            tipo_lead: plan,
                            gclid: gclid,
                            origin,
                            fecha: moment().format("DD-MM-YYYY hh:mm a"),
                            error: Object.values(submit?.ERROR).length > 0 ? JSON.stringify(submit?.ERROR) : 'Error',
                            landing: "entel"
                        });

                        setInfo(false);
                        setLoading(false);
                        setSuccess(false);
                        setDuplicidad(false);
                        if (linkRedirect) {
                            window.open(linkRedirect, '_blank');
                        }
                        buttonRef.current = true;
                        return true;
                    } else {
                        return false;
                    };
                } else {
                    const newToken = await executeRecaptcha("submit_form");
            
                    if (!newToken) {
                        await updateData('updateRequestGenesys', {
                            phone: parseInt(valuePhone?.replace('+56', '')),
                            insertGenesys: 'Error al generar recaptcha',
                        });
                    };

                    const dataSendGenesys = {
                        consulta: {
                            origen: 'publico',
                            tipo: endpointSave === 'saveFibra' ? 'hogar' : 'movil',
                            msisdn: `${valuePhone?.replace('+', '')}`,
                            identification: '',
                            firstName: valueName === '' ? 'form' : valueName,
                            lastName: '',
                            eMailAddress: "",
                            socialMediaName: 'edealer',
                            socialMediaSite: endpointSave === 'saveFibra' ? '10260054' : "10310024",
                            mktCampId: endpointSave === 'saveFibra' ? 'becall-hogar' : 'becall-movil',
                            mktOfferName: `${plan ? plan : ''} - ${price ? price?.replace(/[$.]/g, '') : ''}`
                        },
                        url: `entel-ofertas.cl${location.pathname}`
                    }
                    try {
                        const submitGenesys = await postDataGenesys(dataSendGenesys, newToken);
    
                        let responseGenesys = JSON.stringify(submitGenesys);
                        
                        await updateData('updateRequestGenesys', {
                            phone: parseInt(valuePhone?.replace('+56', '')),
                            insertGenesys: responseGenesys,
                        });
                    } catch (error) {
                        await updateData('updateRequestGenesys', {
                            phone: parseInt(valuePhone?.replace('+56', '')),
                            insertGenesys: `catch de envio de datos Gensys, ${dataSendGenesys}`,
                        });
                    }
                    
                    setInfo(false);
                    setLoading(false);
                    setSuccess(true);
                    setDuplicidad(false);

                    if (submitInitial) {
                        setColorBorderInitial('#002eff');
                        setViewIconRightInitial('');
                        setValuePhoneInitial('');
                    };

                    if (linkRedirect) {
                        window.open(linkRedirect, '_blank');
                    }
                    return true;
                };
            } else {
                if (submit?.STATUS_INSERT === 'duplicidad') {
                    if (view === 'equipos' || view === 'ofertas') {
                        let objDl = {
                            'event': 'GARDNIevent',
                            'eventCategory': `${view === 'equipos' ? 'ecommerce ' : ''}entel ofertas - c2c - conversion`,
                            'eventAction': 'info',
                            'eventLabel': 'carga',
                            'origen': 'entel',
                            'segmento': segmento !== '' ? segmento : segmentoInitial,
                            'mercado': 'pe',
                            'page_owner': 'publico',
                            'form_type': 'c2c',
                            'journey_type': 'solicitud',
                            'journey_name': view,
                            'nombre': encode(valueName.toLowerCase()),
                            'telefono_cliente': encode(valuePhone),
                            'visitor_type': 'nuevo cliente',
                            'page_type': submit?.STATUS_INSERT,
                        };

                        if (seccion === 'movil') {
                            objDl['variant'] = 'formulario card ofertas movil';
                        } else if (seccion === 'hogar') {
                            objDl['variant'] = 'formulario card ofertas hogar';
                        } else if (view === 'equipos') {
                            objDl['variant'] = `formulario card equipo`;
                            objDl['position'] = positionEquipo;
                        } else {
                            objDl['variant'] = `formulario card ofertas ${seccion}`;
                        }

                        window.dataLayer.push(objDl)
                    } if (view === 'plan') {
                        if (intermedia) {
                            if (seccionSelected) {
                                setResponseApi({mensaje: 'Te llamaremos pronto', status: 'duplicidad'});
                                window.dataLayer.push({
                                    event: 'GARDNIevent',
                                    eventCategory: 'planes - c2c lo quiero - conversion',
                                    eventAction: 'info',
                                    eventLabel: 'carga',
                                    origen: 'entel',
                                    mercado: 'pe',
                                    segmento: 'po',
                                    status: "duplicidad",
                                    product_name: plan.toLowerCase(),
                                    product_quantity: '1',
                                    product_price: price.replace(/[$.]/g, ''),
                                    product_subprice: priceTyc.replace(/[$.]/g, ''),
                                    form_step_name: `paso 2 - estas solicitando plan ${plan.toLowerCase()}`,
                                    phone_client: encode(valuePhone),
                                    form_type: "c2c",
                                    journey_name : `plan ${seccionSelected}`,
                                    journey_type: 'solicitud',
                                    page_owner: 'movil',
                                    page_category: 'landing-comercial',
                                    variant_1: "Te llamaremos pronto"
                                })
                            } else {
                                window.dataLayer.push({
                                    'event': 'GARDNIevent',
                                    'eventCategory': seccion === 'Hogar' ? `entel hogar - ${linkRedirect ? 'flujo digital' : 'c2c'} lo quiero - conversion` : seccion === 'Movil' && `entel ofertas - movil - ${linkRedirect ? 'flujo digital' : 'c2c'} planes conversion`,
                                    'eventAction': 'info',
                                    'eventLabel': 'carga',
                                    'origen': 'entel',
                                    'segmento': seccion === 'Hogar' ? 'hh' : 'po',
                                    'mercado': 'pe',
                                    'page_owner': 'publico',
                                    'page_type': submit?.STATUS_INSERT,
                                    'form_name': 'Te ayudamos a contratar',
                                    'form_step_name': 'paso 2 - recibimos tu solicitud - nuevo cliente',
                                    'form_type': linkRedirect ? 'flujo digital' : 'c2c',
                                    'journey_type': 'solicitud',
                                    'journey_name': seccion === 'Hogar' ? 'hogar' : 'movil',
                                    'nombre': encode(valueName.toLowerCase()),
                                    'telefono_cliente': encode(valuePhone),
                                    'eventPlan': seccion === 'Hogar' ? typePlanSelected === 'duo' ? `duo fibra ${typePlan.toLowerCase()}` : `fibra ${plan?.toLowerCase()}` : plan.toLowerCase(),
                                    'price': price.replace(/[$.]/g, ''),
                                    'plan_subprice': priceTyc.replace(/[$.]/g, ''),
                                    'type_offer': descuento.replace('%', 'porciento dcto'),
                                    'visitor_type': 'nuevo cliente',
                                })
                            }
                        } else {
                            window.dataLayer.push({
                                'event': 'GARDNIevent',
                                'eventCategory': 'entel ofertas - c2c lo quiero - conversion',
                                'eventAction': 'info',
                                'eventLabel': 'carga',
                                'origen': 'entel',
                                'segmento': segmento,
                                'mercado': 'pe',
                                'page_owner': 'publico',
                                'form_type': 'c2c',
                                'journey_type': 'solicitud',
                                'journey_name': 'movil',
                                'eventPlan': plan.toLowerCase(),
                                'price': price.replace(/[$.]/g, ''),
                                'plan_subprice': priceTyc.replace(/[$.]/g, ''),
                                'type_offer': descuento.replace('%', 'porciento dcto'),
                                'nombre': encode(valueName.toLowerCase()),
                                'telefono_cliente': encode(valuePhone),
                                'visitor_type': 'nuevo cliente',
                                'page_type': submit?.STATUS_INSERT,
                            })
                        }
                    } if (view === 'navbar') {
                        window.dataLayer.push({
                            'event': 'GARDNIevent',
                            'eventCategory': 'entel ofertas - c2c conversion',
                            'eventAction': 'info',
                            'eventLabel': 'carga',
                            'origen': 'entel',
                            'segmento': segmento,
                            'mercado': 'pe',
                            'page_owner': 'publico',
                            'form_type': 'c2c',
                            'journey_type': 'solicitud',
                            'journey_name': journey_name,
                            'nombre': encode(valueName.toLowerCase()),
                            'telefono_cliente': encode(valuePhone),
                            'visitor_type': 'nuevo cliente',
                            'page_type': submit?.STATUS_INSERT,
                            'variant': 'formulario header',
                        })
                    } if (view === 'formulario_directo') {
                        window.dataLayer.push({
                            'event': 'GARDNIevent',
                            'eventCategory': `${view === 'equipos' ? 'ecommerce ' : ''}entel ofertas - c2c directo - conversion`,
                            'eventAction': 'info',
                            'eventLabel': 'carga',
                            'origen': 'entel',
                            'segmento': segmento,
                            'mercado': 'pe',
                            'page_owner': 'publico',
                            'form_type': 'c2c',
                            'journey_type': 'solicitud',
                            'journey_name': journey_name,
                            'telefono_cliente': encode(valuePhone),
                            'visitor_type': 'nuevo cliente',
                            'page_type': submit?.STATUS_INSERT,
                            'variant': 'c2c directo inferior'
                        })
                    } if (view === 'banner') {
                        window.dataLayer.push({
                            'event': 'GARDNIevent',
                            'eventCategory': 'entel ofertas - banner principal c2c - conversion',
                            'eventAction': 'info',
                            'eventLabel': 'carga',
                            'origen': 'entel',
                            'segmento': segmento,
                            'mercado': 'pe',
                            'page_owner': 'publico',
                            'journey_type': 'solicitud',
                            'nombre': encode(valueName.toLowerCase()),
                            'telefono_cliente': encode(valuePhone),
                            'visitor_type': 'nuevo cliente',
                            'variant': `formulario banner principal ${journey_name}`,
                            'page_type': submit?.STATUS_INSERT,
                        })
                    };

                    setInfo(false);
                    setLoading(false);
                    setSuccess(false);
                    setDuplicidad(true);
                    if (submitInitial) {
                        setColorBorderInitial('#002eff');
                        setViewIconRightInitial('');
                        setValuePhoneInitial('');
                    };
                    if (linkRedirect) {
                        window.open(linkRedirect, '_blank');
                    }
                    return true;
                } else {
                    if (countAgain === 3) {
                        if (seccionSelected) {
                            setResponseApi({mensaje: 'servicio no disponible', status: 'error'});
                            window.dataLayer.push({
                                event: 'GARDNIevent',
                                eventCategory: 'planes - c2c lo quiero - conversion',
                                eventAction: 'info',
                                eventLabel: 'carga',
                                origen: 'entel',
                                mercado: 'pe',
                                segmento: 'po',
                                status: "error",
                                product_name: plan.toLowerCase(),
                                product_quantity: '1',
                                product_price: price.replace(/[$.]/g, ''),
                                product_subprice: priceTyc.replace(/[$.]/g, ''),
                                form_step_name: `paso 2 - estas solicitando plan ${plan.toLowerCase()}`,
                                phone_client: encode(valuePhone),
                                form_type: "c2c",
                                journey_name : `plan ${seccionSelected}`,
                                journey_type: 'solicitud',
                                page_owner: 'movil',
                                page_category: 'landing-comercial',
                                variant_1: "servicio no disponible"
                            })
                        }

                        await postEmail('emails', {
                            telefono_cliente: parseInt(valuePhone.replace('+56', '')),
                            nombre_cliente: valueName === '' ? 'form' : valueName,
                            tipo_lead: plan,
                            gclid: gclid,
                            origin,
                            fecha: moment().format("DD-MM-YYYY hh:mm a"),
                            error: Object.values(submit?.ERROR).length > 0 ? JSON.stringify(submit?.ERROR) : 'Error',
                            landing: "entel"
                        });

                        setInfo(false);
                        setLoading(false);
                        setSuccess(false);
                        setDuplicidad(false);
                        setLoadingRetry(false);
                        if (linkRedirect) {
                            window.open(linkRedirect, '_blank');
                        }
                        buttonRef.current = true;
                        return true;
                    } else {
                        return false;
                    }
                };
            };
        };
    };

    const handleSubmitLead = async ({retry}) => {
        if (enviroments.urlBase === '') {
            if (!buttonRef.current) {
                if (retry) {
                    window.dataLayer.push({
                        event: 'GARDevent',
                        eventCategory: 'planes - c2c lo quiero - conversion',
                        eventAction: 'click to action',
                        eventLabel: 'Volver a intentar',
                        origen: 'entel',
                        mercado: 'pe',
                        segmento: 'po',
                        status: "error",
                        product_name: plan.toLowerCase(),
                        product_quantity: '1',
                        product_price: price?.replace(/[$.]/g, ''),
                        product_subprice: priceTyc?.replace(/[$.]/g, ''),
                        form_step_name: `paso 2 - estas solicitando plan ${plan.toLowerCase()}`,
                        phone_client: encode(valuePhone),
                        form_type: "c2c",
                        journey_name : `plan ${seccionSelected}`,
                        journey_type: 'solicitud',
                        page_owner: 'movil',
                        page_category: 'landing-comercial',
                        variant_1: "servicio no disponible",
                    })
                }
    
                buttonRef.current = true;
                setTryAgain(tryAgain + 1);
                setLoadingRetry(true);
                setLoading(true);
    
                let journey_name = '';
                let endpointSave = '';
                let segmento = '';
    
                if (location.pathname.includes(`${enviroments.urlBase}/ofertas`)) { segmento = 'po'; journey_name = 'ofertas'; endpointSave = segmentoInitial === 'hh' ? 'saveFibra' : 'save' };
                if (location.pathname.includes(`${enviroments.urlBase}/internet-hogar`) || location.pathname === `${enviroments.urlBase}/contratacion`) { segmento = 'hh'; journey_name = 'hogar'; endpointSave = 'saveFibra' };
                if (location.pathname.includes(`${enviroments.urlBase}/planes-moviles`) || location.pathname === `${enviroments.urlBase}/` || location.pathname === `${enviroments.urlBase}/contratacionMovil`) { segmento = 'po'; journey_name = 'movil'; endpointSave = 'save' };
                if (location.pathname.includes(`${enviroments.urlBase}/equipos`)) { segmento = 'tm-equ'; journey_name = 'equipos'; endpointSave = 'save' };
                
                if (view === 'equipos' || view === 'ofertas') {
    
                    let textVariant = `formulario card ${view === 'equipos' ? 'equipo' : 'ofertas'}`
    
                    if (id === 'oferta-tarjeta-movil') {
                        textVariant = 'formulario card ofertas movil'
                    } else if (id === 'oferta-tarjeta-hogar') {
                        textVariant = 'formulario card ofertas hogar'
                    }
    
                    window.dataLayer.push({
                        'event': 'GARDevent',
                        'eventCategory': 'entel ofertas - c2c',
                        'eventAction': 'click to action',
                        'eventLabel': 'quiero que me llamen',
                        'origen': 'entel',
                        'segmento': segmento !== '' ? segmento : segmentoInitial,
                        'mercado': 'pe',
                        'page_owner': 'publico',
                        'form_type': 'c2c',
                        'journey_type': 'solicitud',
                        'journey_name': view,
                        'nombre': encode(valueName.toLowerCase()),
                        'telefono_cliente': encode(valuePhone),
                        'visitor_type': 'nuevo cliente',
                        'page_type': 'registro',
                        'variant': textVariant
                    })
                } if (view === 'plan') {
                    seccion === 'Movil'
                        ? window.dataLayer.push({
                            event: 'GARDevent',
                            eventCategory: 'planes - c2c lo quiero',
                            eventAction: 'click to action',
                            eventLabel: 'quiero que me llamen',
                            origen: 'entel',
                            mercado: 'pe',
                            segmento: 'po',
                            product_name: plan.toLowerCase(),
                            product_quantity: '1',
                            product_price: price.replace(/[$.]/g, ''),
                            product_subprice: priceTyc.replace(/[$.]/g, ''),
                            form_step_name: `paso 1 - estas solicitando plan ${plan.toLowerCase()}`, // paso 1 - estas solicitando plan 350 gigas
                            phone_client: encode(valuePhone),
                            form_type: "c2c",
                            journey_name: typePlanSelected === 'portabilidad' ? `plan portabilidad` : `plan linea nueva`,
                            journey_type: 'solicitud',
                            page_owner: 'movil',
                            page_category: 'landing-comercial',
                        })
                        : window.dataLayer.push({
                            'event': 'GARDevent',
                            'eventCategory': `entel ofertas - 
                            
                            
                            ${linkRedirect ? 'flujo digital' : 'c2c'} lo quiero`,
                            'eventAction': 'click to action',
                            'eventLabel': 'Quiero que me llamen',
                            'origen': 'entel',
                            'segmento': seccion === 'Hogar' ? 'hh' : 'po',
                            'mercado': 'pe',
                            'page_owner': 'publico',
                            'page_type': 'registro',
                            'journey_type': 'solicitud',
                            'form_name': 'Te ayudamos a contratar',
                            'form_step_name': 'paso 1 - recibimos tu solicitud - nuevo cliente',
                            'form_type': linkRedirect ? 'flujo digital' : 'c2c',
                            'journey_name': seccion === 'Hogar' ? 'hogar' : 'movil',
                            'nombre': encode(valueName.toLowerCase()),
                            'telefono_cliente': encode(valuePhone),
                            'eventPlan': plan.toLowerCase(),
                            'price': price.replace(/[$.]/g, ''),
                            'plan_subprice': priceTyc.replace(/[$.]/g, ''),
                            'type_offer': descuento.replace('%', 'porciento dcto'),
                            'visitor_type': 'nuevo cliente',
                        })
                } if (view === 'navbar') {
                    window.dataLayer.push({
                        'event': 'GARDevent',
                        'eventCategory': 'entel ofertas - c2c',
                        'eventAction': 'click to action',
                        'eventLabel': 'quiero que me llamen',
                        'origen': 'entel',
                        'segmento': segmento,
                        'mercado': 'pe',
                        'page_owner': 'publico',
                        'form_type': 'c2c',
                        'journey_type': 'solicitud',
                        'journey_name': journey_name,
                        'nombre': encode(valueName.toLowerCase()),
                        'telefono_cliente': encode(valuePhone),
                        'visitor_type': 'nuevo cliente',
                        'page_type': 'registro',
                        'variant': 'formulario header',
                    });
                } if (view === 'formulario_directo') {
                    window.dataLayer.push({
                        'event': 'GARDevent',
                        'eventCategory': 'entel ofertas - c2c directo',
                        'eventAction': 'click to action',
                        'eventLabel': 'quiero que me llamen',
                        'origen': 'entel',
                        'segmento': segmento,
                        'mercado': 'pe',
                        'page_owner': 'publico',
                        'form_type': 'c2c',
                        'journey_type': 'solicitud',
                        'journey_name': journey_name,
                        'telefono_cliente': encode(valuePhone),
                        'visitor_type': 'nuevo cliente',
                        'page_type': 'registro',
                        'variant': 'c2c directo inferior'
                    })
                } if (view === 'banner') {
                    window.dataLayer.push({
                        'event': 'GARDevent',
                        'eventCategory': 'entel ofertas - banner principal lo quiero',
                        'eventAction': 'click to action',
                        'eventLabel': 'quiero que me llamen',
                        'origen': 'entel',
                        'segmento': segmento,
                        'mercado': 'pe',
                        'page_owner': 'publico',
                        'journey_type': 'solicitud',
                        'nombre': encode(valueName.toLowerCase()),
                        'telefono_cliente': encode(valuePhone),
                        'visitor_type': 'nuevo cliente',
                        'variant': typePlanSelected === 'duo' ? `formulario banner principal hogar duo` : `formulario banner principal ${journey_name}`,
                        'page_type': 'registro',
                    })
                }
    
                if (tryAgain === 2) {
                    window.location.reload();
                    return false;
                };
    
                let countAgain = 0;
    
                while (countAgain <= 3) {
                    const stateSubmit = await submitLead(endpointSave, journey_name, segmento, countAgain, campaignid, adgroupid, keyword, adId, window.location.href);
    
                    if (!stateSubmit) {
                        countAgain++
                    } else {
                        buttonRef.current = false;
                        break;
                    }
                }
                setLoadingRetry(false);
            }
        }
    };

    const updateValueName = (e) => {
        const value = e.target.value;
        setValueName(value);
        if (valuePhone.length === 12 && value.length > 0 && accepted) {
            setDisabledButton(false);
        } else {
            setDisabledButton(true);
        }
    };

    const handleNavigateHogar = () => {
        window.dataLayer.push({
            event: 'GARDevent',
            eventCategory: 'planes - c2c lo quiero - conversion',
            eventAction: 'go to',
            eventLabel: 'banner planes internet hogar',
            origen: 'entel-ofertas',
            mercado: 'pe',
            segmento: 'po',
            status: responseApi?.status,
            product_name: plan.toLowerCase(),
            product_quantity: '1',
            product_price: price.replace(/[$.]/g, ''),
            product_subprice: priceTyc.replace(/[$.]/g, ''),
            form_step_name: `paso 2 - estas solicitando plan ${plan.toLowerCase()}`,
            phone_client: encode(valuePhone),
            form_type: "c2c",
            journey_name : `plan ${seccionSelected}`,
            journey_type: 'solicitud',
            page_owner: 'movil',
            page_category: 'landing-comercial',
            variant_1: responseApi?.mensaje
        });
        navigate(`${enviroments.urlBase}/internet-hogar`);
    };

    return (
        <>
            {
                isMobile
                    ? <Slide direction='bottom' in={isOpenToggle} style={{ zIndex: 10 }}>
                        <Box py='7' px='5' bg='white' borderTopRadius='30px'>
                            {
                                !loading &&
                                <Flex>
                                    <Heading className='Subtitle' size='md'>{info ? 'Te ayudamos a contratar' : success ? '¡Recibimos tu solicitud!' : 'Servicio no disponible'}</Heading>
                                    <Spacer />
                                    <IconButton color='#002eff' onClick={() => setOpenSlideModal(!openSlideModal)} variant='link' icon={<AiOutlineClose size='35px' />} _focusVisible={{}} _active={{}} _focus={{}} />
                                </Flex>
                            }

                            {
                                loading
                                    ? <Flex m='auto' justifyContent='center' alignItems='center' my='40'>
                                        <CircularProgress isIndeterminate color='#002EFF' thickness='9px' size='100px' />
                                    </Flex>
                                    : info
                                        ? <>
                                            <Text className='Subtitle' my='7'>Un ejecutivo te contactará lo antes posible</Text>
                                            <Text className="Subtitle" color={colorLabel}>Ingresa tu nombre*</Text>
                                            <Input borderRadius='6px' value={valueName} onChange={(e) => updateValueName(e)} />
                                            <Text className="Subtitle" color={colorLabel}>Ingresa tu número*</Text>
                                            <InputGroup bg='white' size='lg'>
                                                <InputLeftElement pointerEvents='none'>
                                                    <IconPhone color='#66686C' />
                                                </InputLeftElement>
                                                <Input className="General" inputMode='tel' maxLength='12' value={valuePhone} borderBottom={viewIconRight !== '' && `2px solid ${colorBorder}`} onBlur={() => { valuePhone === '+56' && setValuephone(''); setColorLabel('black') }} onChange={(e) => handleChangeInput(e.target.value)} borderRadius='6px' placeholder='Ej: 912345678' onFocus={() => { valuePhone === '' && setValuephone('+56'); setColorLabel('#002eff') }} _focusVisible={{ variant: 'flushed', bg: '#F3F5FF', borderBottom: `2px solid ${colorBorder}` }} />
                                                {
                                                    viewIconRight !== '' &&
                                                    <InputRightElement>
                                                        {
                                                            viewIconRight === 'Error' ? <IconError size='20px' /> : <IconCheck size='20px' />
                                                        }
                                                    </InputRightElement>
                                                }
                                            </InputGroup>
                                            {
                                                textError && <Text color='red' className='General' fontSize='sm'>El número de teléfono es incorrecto</Text>
                                            }

                                            <Checkbox mt='4' isChecked={accepted} onChange={handleAcceptedChange} iconColor='white' sx={{ '> span:first-of-type': { bg: accepted ? '#002eff' : 'white', borderColor: '#002eff' }, '_checked': { '> span:first-of-type': { bg: '#002eff', borderColor: '#002eff' } } }}>
                                                <Text className='General' fontSize='sm'>
                                                    Acepto los <Link onClick={(e) => { e.preventDefault(); e.stopPropagation(); onOpenTerms(); }} color='#002eff' textDecoration='underline'>Términos y condiciones</Link> y <Link onClick={(e) => { e.stopPropagation(); }} href='https://becallgroup.com/politica-privacidad-latam-generacion/' target='_blank' color='#002eff' textDecoration='underline'>Política de privacidad de datos</Link>
                                                </Text>
                                            </Checkbox>

                                            <Checkbox mt='4' isChecked={acceptedComunicaciones} onChange={(e) => setAcceptedComunicaciones(e.target.checked)} iconColor='white' sx={{ '> span:first-of-type': { bg: acceptedComunicaciones ? '#002eff' : 'white', borderColor: '#002eff' }, '_checked': { '> span:first-of-type': { bg: '#002eff', borderColor: '#002eff' } } }}>
                                                <Text className='General' fontSize='sm'>
                                                    Acepto recibir comunicaciones comerciales de Entel. <Link onClick={(e) => { e.preventDefault(); e.stopPropagation(); onOpenComunicaciones(); }} color='#002eff' textDecoration='underline'>Revisa aquí tus consentimientos.</Link>
                                                </Text>
                                            </Checkbox>

                                            <Button w='100%' isLoading={loadingRetry} className='Subtitle' id={id} onClick={() => handleSubmitLead({retry:false})} bg={!disabledButton ? '#002eff' : 'gray.300'} color={!disabledButton ? 'white' : 'gray.700'} _hover={{}} mt='7' isDisabled={disabledButton} borderRadius='30px' size='lg'>
                                                {messageButton}
                                            </Button>

                                            <Divider h='1px' my='7' />

                                            <Flex bg='#F3F5FF' p='5'>
                                                <IconInfo size='45px' />
                                                <Box ml='4' my='auto'>
                                                    <Text className='Subtitle'>
                                                        Horario de atención: Lunes a Sábado de 10:00 a 20:00 hrs.
                                                    </Text>
                                                </Box>
                                            </Flex>
                                        </>
                                        :
                                        success
                                            ? <>
                                                <Box>
                                                    {
                                                        seccionSelected && <Flex justifyContent='center' alignItems='center' mt='5'>
                                                            <Image cursor='pointer' onClick={() => handleNavigateHogar()} src={bannerHogar} alt='Oferta Hogar Entel' />
                                                        </Flex>
                                                    }

                                                    <Flex mx='auto' justifyContent='center' my='10'>
                                                        <VectorSuccess />
                                                    </Flex>

                                                    <Text className='Subtitle' fontSize='lg'>
                                                        Pronto te llamaremos al número que compartiste. Te recomendamos tener el teléfono cerca.
                                                    </Text>

                                                    <Flex bg='#F3F5FF' p='2' mt='7' borderRadius='6px' mb='4'>
                                                        <IconInfo size='30px' />
                                                        <Box ml='4' my='auto'>
                                                            <Text className='Subtitle'>
                                                                Para brindarte una mejor atención, esta conversación podría ser grabada.
                                                            </Text>
                                                        </Box>
                                                    </Flex>
                                                </Box>
                                            </>
                                            : <>
                                                <Box>
                                                    <Flex mx='auto' justifyContent='center' my='7'>
                                                        <VectorError />
                                                    </Flex>

                                                    <Text className='Subtitle' mb='2'>
                                                        Lamentablemente, en estos momentos no
                                                        podemos ingresar tu solicitud para
                                                        contactarte. Inténtalo nuevamente.
                                                    </Text>

                                                    <Button size='lg' w='100%' className='Subtitle' onClick={() => handleSubmitLead({retry:true})} bg='#002eff' color='white' _hover={{ bg: 'transparent', color: '#002eff', border: '2px solid #002eff' }} my='5' borderRadius='30px'>
                                                        Volver a intentar
                                                    </Button>

                                                    <Divider h='1px' mb='5' />
                                                </Box>
                                            </>
                            }
                        </Box>
                    </Slide>
                    : <Modal blockScrollOnMount={false} isOpen={isOpen} closeOnOverlayClick={false} onClose={onClose} size='xl' isCentered>
                        <ModalContent borderRadius='15px' py='2'>
                            <ModalHeader>
                                <Flex>
                                    {
                                        !loading && <Heading className='Subtitle' size='md'>{info ? 'Te ayudamos a contratar' : success ? '¡Recibimos tu solicitud!' : 'Servicio no disponible'}</Heading>
                                    }
                                    <Spacer />
                                    <IconButton color='#002eff' onClick={() => setOpenSlideModal(!openSlideModal)} variant='link' icon={<AiOutlineClose size='35px' />} _focusVisible={{}} _active={{}} _focus={{}} />
                                </Flex>
                            </ModalHeader>
                            <ModalBody>
                                {
                                    loading
                                        ?
                                        <Flex m='auto' justifyContent='center' alignItems='center' mt='20' mb='40'>
                                            <CircularProgress isIndeterminate color='#002EFF' thickness='9px' size='100px' />
                                        </Flex>
                                        :
                                        info
                                            ? <>
                                                {
                                                    messageButton !== 'Contratar Online' 
                                                    && <Text className='Subtitle' mb='7'>Un ejecutivo te contactará lo antes posible</Text>
                                                }

                                                <Text className="Subtitle" color={colorLabel}>Ingresa tu nombre*</Text>
                                                <Input borderRadius='6px' value={valueName} onChange={(e) => updateValueName(e)} />

                                                <Text className="Subtitle" mt='3' color={colorLabel}>Ingresa tu número*</Text>
                                                <InputGroup bg='white' size='lg'>
                                                    <InputLeftElement pointerEvents='none'>
                                                        <IconPhone color='#66686C' />
                                                    </InputLeftElement>
                                                    <Input className="General" inputMode='tel' maxLength='12' value={valuePhone} borderBottom={viewIconRight !== '' && `2px solid ${colorBorder}`} onBlur={() => { valuePhone === '+56' && setValuephone(''); setColorLabel('black') }} onChange={(e) => handleChangeInput(e.target.value)} borderRadius='6px' placeholder='Ej: 912345678' onFocus={() => { valuePhone === '' && setValuephone('+56'); setColorLabel('#002eff') }} _focusVisible={{ variant: 'flushed', bg: '#F3F5FF', borderBottom: `2px solid ${colorBorder}` }} />
                                                    {
                                                        viewIconRight !== '' &&
                                                        <InputRightElement>
                                                            {
                                                                viewIconRight === 'Error' ? <IconError size='20px' /> : <IconCheck size='20px' />
                                                            }
                                                        </InputRightElement>
                                                    }
                                                </InputGroup>
                                                {
                                                    textError && <Text color='red' className='General' fontSize='sm'>El número de teléfono es incorrecto</Text>
                                                }

                                                <Checkbox mt='4' isChecked={accepted} onChange={handleAcceptedChange} iconColor='white' sx={{ '> span:first-of-type': { bg: accepted ? '#002eff' : 'white', borderColor: '#002eff' }, '_checked': { '> span:first-of-type': { bg: '#002eff', borderColor: '#002eff' } } }}>
                                                    <Text className='General' fontSize='sm'>
                                                        Acepto los <Link onClick={(e) => { e.preventDefault(); e.stopPropagation(); onOpenTerms(); }} color='#002eff' textDecoration='underline'>Términos y condiciones</Link> y <Link onClick={(e) => { e.stopPropagation(); }} href='https://becallgroup.com/politica-privacidad-latam-generacion/' target='_blank' color='#002eff' textDecoration='underline'>Política de privacidad de datos</Link>
                                                    </Text>
                                                </Checkbox>

                                                <Checkbox mt='4' isChecked={acceptedComunicaciones} onChange={(e) => setAcceptedComunicaciones(e.target.checked)} iconColor='white' sx={{ '> span:first-of-type': { bg: acceptedComunicaciones ? '#002eff' : 'white', borderColor: '#002eff' }, '_checked': { '> span:first-of-type': { bg: '#002eff', borderColor: '#002eff' } } }}>
                                                    <Text className='General' fontSize='sm'>
                                                        Acepto recibir comunicaciones comerciales de Entel. <Link onClick={(e) => { e.preventDefault(); e.stopPropagation(); onOpenComunicaciones(); }} color='#002eff' textDecoration='underline'>Revisa aquí tus consentimientos.</Link>
                                                    </Text>
                                                </Checkbox>

                                                <Button w='70%' className='Subtitle' mx='auto' id={id} display='flex' onClick={() => handleSubmitLead({retry:false})} bg={!disabledButton ? '#002eff' : 'gray.300'} color={!disabledButton ? 'white' : 'gray.700'} _hover={{ bg: 'transparent', color: '#002eff', border: '2px solid #002eff' }} my='5' isDisabled={disabledButton} borderRadius='30px' size='lg'>
                                                    {messageButton}
                                                </Button>

                                                <Divider h='1px' mb='7' />

                                                {
                                                    messageButton !== 'Contratar Online' 
                                                    &&  <Flex bg='#F3F5FF' p='2' mt='7'>
                                                        <IconInfo size='30px' />
                                                        <Box ml='4' my='auto'>
                                                            <Text className='Subtitle'>
                                                                Horario de atención: Lunes a Sábado de 10:00 a 20:00 hrs.
                                                            </Text>
                                                        </Box>
                                                    </Flex>
                                                }
                                            </>
                                            :
                                            success
                                                ? <>
                                                    <Box>
                                                        {
                                                            seccionSelected && <Flex justifyContent='center' mb='5'>
                                                                <Image cursor='pointer' onClick={() => handleNavigateHogar()} src={bannerHogar} alt='Oferta Hogar Entel' />
                                                            </Flex>
                                                        }

                                                        <Flex m='auto' justifyContent='center'>
                                                            <VectorSuccess />
                                                        </Flex>

                                                        <Text mt='7' className='Subtitle'>
                                                            Pronto te llamaremos al número que compartiste. Te recomendamos tener el teléfono cerca.
                                                        </Text>

                                                        <Flex bg='#F3F5FF' p='2' mt='7' borderRadius='6px'>
                                                            <IconInfo size='30px' />
                                                            <Box ml='4' my='auto'>
                                                                <Text className='Subtitle'>
                                                                    Para brindarte una mejor atención, esta conversación podría ser grabada.
                                                                </Text>
                                                            </Box>
                                                        </Flex>
                                                    </Box>
                                                </>
                                                : duplicidad 
                                                    ? <>
                                                        <Box>
                                                            <Flex m='auto' justifyContent='center'>
                                                                <VectorDuplicidad />
                                                            </Flex>

                                                            <Text mt='7' className='Subtitle'>
                                                                Ya ingresaste una solicitud para contactarte. Recibimos tu información y te llamaremos lo más pronto posible.
                                                            </Text>

                                                            <Flex bg='#F3F5FF' p='2' mt='4' borderRadius='6px'>
                                                                <IconInfo size='30px' />
                                                                <Box ml='4' my='auto'>
                                                                    <Text className='Subtitle'>
                                                                        Para brindarte una mejor atención, esta conversación podría ser grabada.
                                                                    </Text>
                                                                </Box>
                                                            </Flex>
                                                        </Box>
                                                    </>
                                                    : <>
                                                        <Box>
                                                            <Flex m='auto' justifyContent='center'>
                                                                <VectorError />
                                                            </Flex>

                                                            <Text mt='7' className='Subtitle'>
                                                                Lamentablemente, en estos momentos no
                                                                podemos ingresar tu solicitud para
                                                                contactarte. Inténtalo nuevamente.
                                                            </Text>

                                                            <Button size='lg' isLoading={loadingRetry} w='70%' onClick={() => handleSubmitLead({retry:true})} className='Subtitle' mx='auto' display='flex' bg='#002eff' color='white' _hover={{ bg: 'transparent', color: '#002eff', border: '2px solid #002eff' }} my='7' borderRadius='30px'>
                                                                Volver a intentar
                                                            </Button>

                                                            <Divider h='1px' mb='7' />
                                                        </Box>
                                                    </>
                                }
                            </ModalBody>
                        </ModalContent>
                    </Modal>
            }

            {/* Modal Términos y Condiciones */}
            <Modal isOpen={isOpenTerms} blockScrollOnMount={false} onClose={onCloseTerms} isCentered size="3xl" scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent borderRadius="15px" maxH="90vh">
                    <ModalHeader className='Subtitle' fontWeight='0' fontSize='3xl'>Términos y Condiciones</ModalHeader>
                    <ModalCloseButton color="black" />
                    <ModalBody py="6">
                        <Text className='General'>
                            Aspectos Generales<br />
                            Los presentes Términos y Condiciones de Entel PCS (Entel PCS Telecomunicaciones. S.A.M, Rut: 96.80-6.980-2, representada por su gerente general don Antonio Büchi Buc, cédula de identidad N°9.989.661-2. Con Dirección comercial Av. Costanera Sur N°2760,Piso 22, Las Condes, Santiago)), (“Entel”) aplican para las compras y contrataciones a través del sitio <a href='https://www.entel.cl' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl</a> y a las transacciones que se realicen a través de la APP de Entel y Mi Entel (denominados “canales digitales”) relativas a Planes Móviles y/o Equipos y Accesorios. Así también aplican para el uso de todo usuario o consumidor.<br />

                            Los Términos y Condiciones deberán ser aceptados por el usuario y son incorporados en todas las compras de productos y contrataciones de servicios antes señaladas.<br />

                            Los Términos y Condiciones están sometidos a las leyes de la República de Chile, específicamente las que protegen los derechos de los consumidores.<br />

                            Libertad para comparar, comprar y solicitar la contratación de productos y servicios
                            El usuario queda en libertad de navegar por todo el sitio entel.cl y sus canales digitales para cotizar y comparar productos y servicios, lo cual no impone obligación alguna a Entel de proveer tales productos o servicios a menos que el usuario haya expresado mediante actos explícitos su voluntad a través de la totalidad de pasos indicados en los Términos y Condiciones. La sola visita al sitio entel.cl no impone obligación alguna al consumidor, a menos que haya aceptado de forma inequívoca las condiciones en él ofrecidas.<br />

                            Cómo comprar productos y/o solicitar la contratación de servicios en Entel.cl y Canales Digitales
                            Para realizar una compra y/o contratar un servicio, el usuario deberá seguir los siguientes pasos:<br />
                            
                            <UnorderedList pl='5'>
                                <ListItem>Seleccionar los productos y/o servicios que desea contratar y/o solicitar.</ListItem>
                                <ListItem>De corresponder, seleccionar el tipo de despacho que se desea para la entrega o recepción de los productos y servicios contratados. En el caso de seleccionar Despacho Programado o Despacho Express, el usuario deberá ingresar la dirección de despacho. En el caso de seleccionar Retiro en Tienda, el usuario podrá hacer retiro del producto con su cédula de identidad y la boleta de venta (si aplica).</ListItem>
                                <ListItem>Leer los Términos y Condiciones y aceptarlos.</ListItem>
                                <ListItem>Si la transacción requiere un pago por parte del Cliente al momento de la venta, el usuario deberá seleccionar el método de pago y realizar el pago según los pasos indicados por Webpay y/o el botón de Banco Estado.</ListItem>
                            </UnorderedList>
                            
                            <Text pl='5'>
                                a. Una vez confirmada la transacción de pago, será enviado un correo electrónico al correo indicado en el paso 2, confirmando la compra o la solicitud de contratación de servicios.<br />
                                b. Confirmado el pago, será enviado un correo electrónico al correo indicado en el paso 2, la boleta de venta respectiva.
                            </Text>
                            
                            Dependiendo del método de despacho seleccionado, será enviado un correo electrónico al mail indicado en el paso 2, con el acceso para realizar seguimiento a la compra y/o confirmación y recordatorios para el retiro del producto y/o SIMCard en la Tienda seleccionada en el paso 3.<br />

                            Una vez entregado o retirado el producto o servicio contratado, se hará envío - si corresponde -, de los contratos de servicios y anexos que aplican. Estos también quedarán disponibles en el sitio Mi Entel y serán enviados vía correo al usuario.<br />

                            (*) Es de exclusiva responsabilidad del usuario, asegurar que la información ingresada correspondiente a datos personales, datos de contacto y dirección de despacho entregados al momento de la compra o solicitud sea verídica y correcta, de esta forma Entel puede asegurar el contacto y proceder con atenciones de postventa sin dificultades en caso de ser necesario. En caso de error en el envío de los datos, el usuario podrá comunicarse al 103 o desde cualquier teléfono red fija al número 600 3600 103 o a través del Chat ClaudIA en entel.cl, con hasta 24 horas de anticipación del despacho. Si la rectificación es relativa a la dirección, la nueva deberá encontrarse dentro de la comuna originalmente ingresada. De lo contrario, Entel se encontrará facultado para anular la transacción o reagendar la fecha de despacho previa coordinación con el usuario. Los errores en los datos personales motivarán la anulación de la contratación.<br />

                            Condiciones generales de los Planes Móviles Entel
                            La contratación y la cantidad de planes está sujeta a evaluación comercial.<br />

                            Una vez finalizado el mes calendario los servicios del plan se reiniciarán a contar del primer día del mes siguiente.<br />

                            Los planes tendrán las políticas de fraude y administración de tráfico que Entel aplica a sus planes. Más información en <a href='https://www.entel.cl/neutralidad' style={{ color: '#002EFF' }} target='_blank'>www.entel.cl/neutralidad</a>.

                            Los servicios, salvo roaming, son de uso exclusivo dentro de territorio nacional, excluyendo zonas con tarifas especiales e Isla de Pascua.<br />

                            Los planes Gigas 16.990, Libre 23.990, Libre Roaming 29.990 y Libre Roaming Pro 39.990 incluyen llamadas de voz originadas y terminadas dentro de Chile en una cantidad libre de minutos hasta 300 números distintos en un mes o hasta alcanzar la cantidad de 1.000 minutos en llamadas a un mismo número móvil en un mes. Una vez excedidos estos 300 números o la cantidad de minutos referida, las llamadas a números distintos de los primeros 300 o en exceso de dichos minutos, comenzarán a cobrarse a $99 el minuto.<br />

                            Las tarifas vigentes de los servicios de roaming de voz, datos y SMS dependen del país y se encuentran publicadas en <a href='https://www.entel.cl/roaming' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl/roaming</a>.<br />

                            Larga distancia internacional (LDI) son adicionales al plan contratado. Para conocer tarifas vigentes ingresa a <a href='https://www.entel.cl/ldi' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl/ldi</a>.<br />

                            La cobertura de la red 4G LTE es mayormente en espacios abiertos (outdoor) y la cobertura en espacios cerrados (indoor) se ajusta a la obligación establecida por la Subsecretaría de Telecomunicaciones para esta concesión. Más detalle de cobertura en <a href='https://www.entel.cl' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl</a> sección cobertura móvil.<br />

                            Planes adicionales<br />
                            El descuento “Te Sumo” ofrece líneas adicionales a $10.990. Para acceder a este descuento, el cliente debe tener contratado un plan Te Sumo y acceder a líneas adicionales con descuento bajo el mismo cargo fijo, rut y cuenta.<br />

                            El descuento consiste en que se pagará en una línea el cargo fijo completo y todas sus adicionales $10.990. Esto se aplicará para los planes Te Sumo contratados de igual valor, con un máximo de 4 líneas con descuento.<br />

                            Este beneficio se mantendrá mientras se cumpla la condición que dio origen al descuento.<br />

                            Al momento de contratar más de un plan Te Sumo el cliente accede inmediatamente a los descuentos detallados en éste. En caso de que el cliente decida cambiarse a otro plan fuera del descuento Te Sumo o portar o dar de baja alguna de sus líneas, se cobrará el cargo fijo sin descuento proporcional a los días del mes facturado.<br />

                            El plazo de contratación del descuento Te Sumo es indefinido.<br />

                            Condiciones de los planes vigentes<br />
                            Condiciones Plan Gigas 12.990<br />
                            La contratación de planes está sujeta a evaluación comercial.<br />

                            Los servicios, salvo roaming, son de uso exclusivo dentro de territorio nacional, excluyendo zonas con tarifas especiales e Isla de Pascua.<br />

                            Plan incluye llamadas de voz originadas y terminadas dentro de Chile en una cantidad de 1.000 minutos.<br />

                            Las aplicaciones libres incluidas: WhatsApp, Facebook, Facebook Messenger, Twitter, Spotify, Apple Music, Instagram; incluyen el envío y recepción de mensajes de texto, audios, fotos, videos, contactos y archivos, así como también la actualización de estado. Las llamadas de voz y video llamadas sobre IP (VoIP) no están incluidas en el uso de WhatsApp ni de Facebook. Geolocalización (mapas) y acceso a enlaces externos en cualquiera de las aplicaciones mencionadas descuentan de la cuota de datos mensual del plan.<br />

                            La descarga de las aplicaciones antes mencionadas se descuenta de la cuota de datos mensual del plan. No está incluida la compra de productos o accesorios asociados a las aplicaciones incluidas ni el valor de suscripción que algunas puedan requerir. Para utilizar estas aplicaciones se requiere sistema operativo Android, IOS o Windows.<br />

                            Una vez consumida la cuota de 150 GB de datos del plan, el cliente podrá seguir utilizando Internet Móvil comprando bolsas de datos desde $500 hasta que finalice el mes calendario. Deberá contar con saldo suficiente en el plan para comprar las bolsas de datos.<br />

                            Este plan cuenta con Bono Juntos, por lo tanto, si el cliente tiene contratado y vigente al menos 2 líneas en planes Gigas $12.990 recibirá de forma automática 20 GB adicionales en cada una de estas líneas. La renovación del bono será en cada renovación de los servicios del plan del cliente. Este beneficio se otorgará a un mínimo de 2 líneas y a un máximo de 4 líneas contratadas bajo un mismo rut y cuenta, y se mantendrá mientras se mantenga la condición que da origen a los GB adicionales.<br />

                            El cliente puede llevar el control de su consumo de datos desde su celular ingresando a Mi Entel o App Entel, sección Mi Consumo, sin descontar datos.<br />

                            Condiciones Plan Gigas 16.990<br />
                            La contratación de planes está sujeta a evaluación comercial.<br />

                            Los servicios, salvo roaming, son de uso exclusivo dentro de territorio nacional, excluyendo zonas con tarifas especiales e Isla de Pascua.<br />

                            El cargo fijo mensual incluye llamadas de voz originadas y terminadas dentro de Chile en una cantidad libre de minutos hasta 300 números distintos en un mes o hasta alcanzar la cantidad de 1.000 minutos en llamadas a un mismo número móvil en un mes. Una vez excedidos estos 300 números o la cantidad de minutos referida, las llamadas a números distintos de los primeros 300 o en exceso de dichos minutos, comenzarán a cobrarse a $99 el minuto.<br />

                            Las aplicaciones libres incluidas: WhatsApp, Facebook, Facebook Messenger, Twitter, Spotify, Apple Music, Instagram; incluyen el envío y recepción de mensajes de texto, audios, fotos, videos, contactos y archivos, así como también la actualización de estado. Las llamadas de voz y video llamadas sobre IP (VoIP) no están incluidas en el uso de WhatsApp ni de Facebook. Geolocalización (mapas) y acceso a enlaces externos en cualquiera de las aplicaciones mencionadas descuentan de la cuota de datos mensual del plan.<br />

                            La descarga de las aplicaciones antes mencionadas se descuenta de la cuota de datos mensual del plan. No está incluida la compra de productos o accesorios asociados a las aplicaciones incluidas ni el valor de suscripción que algunas puedan requerir. Para utilizar estas aplicaciones se requiere sistema operativo Android, IOS o Windows.<br />

                            Una vez consumida la cuota de 350 GB de datos del plan, el cliente podrá seguir utilizando Internet Móvil comprando bolsas de datos desde $500 hasta que finalice el mes calendario. Deberá contar con saldo suficiente en el plan para comprar las bolsas de datos.<br />

                            Plan incluye el beneficio Te Sumo, que le permite al cliente acceder a líneas adicionales del mismo plan a $10.990 bajo el mismo rut y cuenta, con un máximo de 4 líneas adicionales con descuento.<br />

                            El cliente puede llevar el control de su consumo de datos desde su celular ingresando a Mi Entel o App Entel, sección Mi Consumo, sin descontar datos.<br />

                            Condiciones Libre 23.990<br />
                            La contratación de planes está sujeta a evaluación comercial.<br />

                            Los servicios, salvo roaming, son de uso exclusivo dentro de territorio nacional, excluyendo zonas con tarifas especiales e Isla de Pascua.<br />

                            El cargo fijo mensual incluye llamadas de voz originadas y terminadas dentro de Chile en una cantidad libre de minutos hasta 300 números distintos en un mes o hasta alcanzar la cantidad de 1.000 minutos en llamadas a un mismo número móvil en un mes. Una vez excedidos estos 300 números o la cantidad de minutos referida, las llamadas a números distintos de los primeros 300 o en exceso de dichos minutos, comenzarán a cobrarse a $99 el minuto.<br />

                            Las aplicaciones libres incluidas: WhatsApp, Facebook, Facebook Messenger, Twitter, Spotify, Apple Music, Instagram; incluyen el envío y recepción de mensajes de texto, audios, fotos, videos, contactos y archivos, así como también la actualización de estado. Las llamadas de voz y video llamadas sobre IP (VoIP) no están incluidas en el uso de WhatsApp ni de Facebook. Geolocalización (mapas) y acceso a enlaces externos en cualquiera de las aplicaciones mencionadas descuentan de la cuota de datos mensual del plan.<br />

                            La descarga de las aplicaciones antes mencionadas se descuenta de la cuota de datos mensual del plan. No está incluida la compra de productos o accesorios asociados a las aplicaciones incluidas ni el valor de suscripción que algunas puedan requerir. Para utilizar estas aplicaciones se requiere sistema operativo Android, IOS o Windows.<br />

                            El plan está destinado a consumidores personas naturales, ya sea suscriptores o usuarios de este servicio público telefónico móvil, entendiendo que estos le dan un uso adecuado y normal, teniendo para ello un perfil de tráfico y uso de red conforme a las prácticas usuales y habituales de este servicio, y por ello no podrá utilizarse con fines distintos a los señalados de dichos consumidores. En relación a lo anterior, Entel se reserva el derecho de efectuar medidas de gestión de tráfico y administración de la red, en función de mantener la debida calidad de red de sus servicios suministrados.<br />

                            Plan incluye el beneficio Te Sumo, que le permite al cliente acceder a líneas adicionales del mismo plan a $10.990 bajo el mismo rut y cuenta, con un máximo de 4 líneas adicionales con descuento.<br />

                            El plan Libre 23.990 cuenta con Whatsapp roaming libre para utilizar en 31 países en convenio: Alemania, Argentina, Australia, Bélgica, Bolivia, Brasil, Canadá, China, Colombia, Costa Rica, Croacia, Ecuador, España, Estados Unidos, Francia, Grecia, Holanda, Israel, Italia, México, Nueva Zelanda, Paraguay, Perú, Portugal, Rep. Checa, Rep. Dominicana, Sudáfrica, Suiza, Tailandia, Reino Unido, Uruguay. Estos países podrían cambiar, el listado actualizado se encuentra en <a href='https://www.entel.cl/roaming' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl/roaming</a>.<br />

                            Dentro de la cuota de Whatsapp roaming se incluye el envío y recepción de mensajes y envío y descarga de archivos. La apertura de links externos, llamadas y videollamadas no están incluidas dentro de esta cuota. Una vez superados los 5 GB de consumo en la aplicación, la velocidad se reducirá a 64 kbps.<br />

                            El cliente puede llevar el control de su consumo de datos desde su celular ingresando a Mi Entel o App Entel, sección Mi Consumo, sin descontar datos.<br />

                            Condiciones Plan Libre Roaming 29.990<br />
                            La contratación de planes está sujeta a evaluación comercial.<br />

                            Los servicios, salvo roaming, son de uso exclusivo dentro de territorio nacional, excluyendo zonas con tarifas especiales e Isla de Pascua.<br />

                            El cargo fijo mensual incluye llamadas de voz originadas y terminadas dentro de Chile en una cantidad libre de minutos hasta 300 números distintos en un mes o hasta alcanzar la cantidad de 1.000 minutos en llamadas a un mismo número móvil en un mes. Una vez excedidos estos 300 números o la cantidad de minutos referida, las llamadas a números distintos de los primeros 300 o en exceso de dichos minutos, comenzarán a cobrarse a $99 el minuto.<br />

                            Las aplicaciones libres incluidas: WhatsApp, Facebook, Facebook Messenger, Twitter, Spotify, Apple Music, Instagram; incluyen el envío y recepción de mensajes de texto, audios, fotos, videos, contactos y archivos, así como también la actualización de estado. Las llamadas de voz y video llamadas sobre IP (VoIP) no están incluidas en el uso de WhatsApp ni de Facebook. Geolocalización (mapas) y acceso a enlaces externos en cualquiera de las aplicaciones mencionadas descuentan de la cuota de datos mensual del plan.<br />

                            La descarga de las aplicaciones antes mencionadas se descuenta de la cuota de datos mensual del plan. No está incluida la compra de productos o accesorios asociados a las aplicaciones incluidas ni el valor de suscripción que algunas puedan requerir. Para utilizar estas aplicaciones se requiere sistema operativo Android, IOS o Windows.<br />

                            El plan está destinado a consumidores personas naturales, ya sea suscriptores o usuarios de este servicio público telefónico móvil, entendiendo que estos le dan un uso adecuado y normal, teniendo para ello un perfil de tráfico y uso de red conforme a las prácticas usuales y habituales de este servicio, y por ello no podrá utilizarse con fines distintos a los señalados de dichos consumidores. En relación a lo anterior, Entel se reserva el derecho de efectuar medidas de gestión de tráfico y administración de la red, en función de mantener la debida calidad de red de sus servicios suministrados.<br />

                            Plan incluye el beneficio Te Sumo, que le permite al cliente acceder a líneas adicionales del mismo plan a $10.990 bajo el mismo rut y cuenta, con un máximo de 4 líneas adicionales con descuento.<br />

                            El plan Libre Roaming 29.990 cuenta con servicio de roaming de 3 GB, 20 minutos, 20 SMS y Whatsapp libre para utilizar en 31 países en convenio: Alemania, Argentina, Australia, Bélgica, Bolivia, Brasil, Canadá, China, Colombia, Costa Rica, Croacia, Ecuador, España, Estados Unidos, Francia, Grecia, Holanda, Israel, Italia, México, Nueva Zelanda, Paraguay, Perú, Portugal, Rep. Checa, Rep. Dominicana, Sudáfrica, Suiza, Tailandia, Reino Unido, Uruguay. Estos países podrían cambiar, el listado actualizado se encuentra en <a href='https://www.entel.cl/roaming' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl/roaming</a>.<br />

                            Si el cliente no hace uso de la cuota de datos, minutos y/o SMS roaming, el saldo no es traspasable al mes siguiente.<br />

                            Los 20 minutos roaming incluidos en el plan permiten recibir y emitir llamadas hacia números en el país que se utiliza el servicio y Chile. Las llamadas emitidas a un tercer país no están consideradas.<br />

                            El cliente puede llevar el control de su consumo de datos desde su celular ingresando a Mi Entel o App Entel, sección Mi Consumo, sin descontar datos.<br />

                            Dentro de la cuota de Whatsapp roaming se incluye el envío y recepción de mensajes y envío y descarga de archivos. La apertura de links externos, llamadas y videollamadas no están incluidas dentro de esta cuota. Una vez superados los 5 GB de consumo en la aplicación, la velocidad se reducirá a 64 kbps.<br />

                            El cliente puede llevar el control de su consumo de datos desde su celular ingresando a Mi Entel o App Entel, sección Mi Consumo, sin descontar datos.<br />

                            Condiciones Plan Libre Roaming Pro 39.990<br />
                            La contratación de planes está sujeta a evaluación comercial.<br />

                            Los servicios, salvo roaming, son de uso exclusivo dentro de territorio nacional, excluyendo zonas con tarifas especiales e Isla de Pascua.<br />

                            El cargo fijo mensual incluye llamadas de voz originadas y terminadas dentro de Chile en una cantidad libre de minutos hasta 300 números distintos en un mes o hasta alcanzar la cantidad de 1.000 minutos en llamadas a un mismo número móvil en un mes. Una vez excedidos estos 300 números o la cantidad de minutos referida, las llamadas a números distintos de los primeros 300 o en exceso de dichos minutos, comenzarán a cobrarse a $99 el minuto.<br />

                            Las aplicaciones libres incluidas: WhatsApp, Facebook, Facebook Messenger, Twitter, Spotify, Apple Music, Instagram; incluyen el envío y recepción de mensajes de texto, audios, fotos, videos, contactos y archivos, así como también la actualización de estado. Las llamadas de voz y video llamadas sobre IP (VoIP) no están incluidas en el uso de WhatsApp ni de Facebook. Geolocalización (mapas) y acceso a enlaces externos en cualquiera de las aplicaciones mencionadas descuentan de la cuota de datos mensual del plan.<br />

                            La descarga de las aplicaciones antes mencionadas se descuenta de la cuota de datos mensual del plan. No está incluida la compra de productos o accesorios asociados a las aplicaciones incluidas ni el valor de suscripción que algunas puedan requerir. Para utilizar estas aplicaciones se requiere sistema operativo Android, IOS o Windows.<br />

                            El plan está destinado a consumidores personas naturales, ya sea suscriptores o usuarios de este servicio público telefónico móvil, entendiendo que estos le dan un uso adecuado y normal, teniendo para ello un perfil de tráfico y uso de red conforme a las prácticas usuales y habituales de este servicio, y por ello no podrá utilizarse con fines distintos a los señalados de dichos consumidores. En relación a lo anterior, Entel se reserva el derecho de efectuar medidas de gestión de tráfico y administración de la red, en función de mantener la debida calidad de red de sus servicios suministrados.<br />

                            Plan incluye el beneficio Te Sumo, que le permite al cliente acceder a líneas adicionales del mismo plan a $10.990 bajo el mismo rut y cuenta, con un máximo de 4 líneas adicionales con descuento.<br />

                            El plan Libre Roaming Pro 39.990 cuenta con servicio de roaming de 10 GB, 40 minutos, 40 SMS y Whatsapp libre para utilizar en 31 países en convenio: Alemania, Argentina, Australia, Bélgica, Bolivia, Brasil, Canadá, China, Colombia, Costa Rica, Croacia, Ecuador, España, Estados Unidos, Francia, Grecia, Holanda, Israel, Italia, México, Nueva Zelanda, Paraguay, Perú, Portugal, Rep. Checa, Rep. Dominicana, Sudáfrica, Suiza, Tailandia, Reino Unido, Uruguay. Estos países podrían cambiar, el listado actualizado se encuentra en <a href='https://www.entel.cl/roaming' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl/roaming</a>.<br />

                            Si el cliente no hace uso de la cuota de datos, minutos y/o SMS roaming, el saldo no es traspasable al mes siguiente.<br />

                            Los 40 minutos roaming incluidos en el plan permiten recibir y emitir llamadas hacia números en el país que se utiliza el servicio y Chile. Las llamadas emitidas a un tercer país no están consideradas.<br />

                            El cliente puede llevar el control de su consumo de datos desde su celular ingresando a Mi Entel o App Entel, sección Mi Consumo, sin descontar datos.<br />

                            Dentro de la cuota de Whatsapp roaming se incluye el envío y recepción de mensajes y envío y descarga de archivos. La apertura de links externos, llamadas y videollamadas no están incluidas dentro de esta cuota. Una vez superados los 5 GB de consumo en la aplicación, la velocidad se reducirá a 64 kbps.<br />

                            El cliente puede llevar el control de su consumo de datos desde su celular ingresando a Mi Entel o App Entel, sección Mi Consumo, sin descontar datos.<br />

                            Portabilidad<br />
                            En caso de solicitar portabilidad desde otras compañías, el usuario deberá tener las siguientes consideraciones:<br />

                            <UnorderedList pl='5'>
                                <ListItem>En caso de existir cobros correspondientes a saldos pendientes no facturados con la compañía de origen, el cliente deberá primero regularizar estos saldos con la compañía origen.</ListItem>
                                <ListItem>En caso de que existan saldos pendientes facturados y vencidos con la compañía de origen, el cliente deberá primero saldar la deuda con la compañía origen.</ListItem>
                                <ListItem>Si actualmente el usuario posee otros servicios suscritos con la compañía origen, estos se mantendrán con las condiciones que la compañía origen disponga.</ListItem>
                                <ListItem>Para utilizar los beneficios del nuevo plan con Entel, el equipo utilizado no debe presentar ningún tipo de bloqueo.</ListItem>
                                <ListItem>No existen cobros asociados al proceso de portabilidad por parte de Entel.</ListItem>
                                <ListItem>La portabilidad se realiza durante la madrugada, por lo que podrías quedar sin servicio mientras ésta se ejecuta. Pasado este periodo, podrás insertar tu SIMCard Entel y comenzar a disfrutar de tu plan.</ListItem>
                            </UnorderedList>

                            Puedes cancelar el proceso de portabilidad hasta las 22:00 horas el día de la entrega de tu chip, llamando desde su móvil Entel al 103 o desde cualquier teléfono red fija al número 600 3600 103 o a través de los medios adicionales que Entel disponga, los que serán informados a través del sitio <a href='https://www.entel.cl' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl</a> en este enlace: ver aquí.<br />

                            Compraventa de Equipos de Telefonía Móvil<br />
                            Los equipos y accesorios que vende Entel son nuevos, a excepción de su línea de equipos y accesorios “Seminuevos” que son productos refaccionados. Todos los equipos y accesorios se encuentran en perfecto estado de funcionamiento.<br />

                            El precio de venta de los equipos puede ser pagado por el comprador de acuerdo con las condiciones que se hayan publicado en el sitio web, pudiendo ser pagado el precio de contado o en cuotas, según lo que informe Entel en cada caso. Lo anterior dependerá de la evaluación económica que Entel realice del contratante.<br />

                            Cuando el pago del precio pueda ser realizado en cuotas, se pagará de la siguiente forma: 1.- con el pago de un pie inicial (o pago mínimo inicial), y 2.- con el pago de las cuotas mensuales, cuyos valores se indicarán en la sección detalle del negocio dentro del Contrato. Entel podrá cobrar dichos valores en el mismo documento de cobro del servicio telefónico móvil si el comprador también es suscriptor de "Entel". Las cuotas mensuales referidas devengarán un interés que no podrá ser superior a la tasa de interés máxima convencional para operaciones de crédito de dinero no reajustables en moneda nacional de menos de 90 días, inferiores o iguales al equivalente de 5.000 unidades de fomento, si el comprador opta por cuotas que se ajusten a dicho plazo. Si el comprador optare por más cuotas mensuales, éstas devengarán un interés que no podrá ser superior a la tasa de interés máxima convencional para operaciones de crédito de dinero no reajustables en moneda nacional de 90 días o más, inferiores o iguales al equivalente de 50 unidades de fomento.<br />

                            En el sitio web de Entel, sección equipos, junto con el precio de los mismos se informa sobre el valor del pie inicial y CAE del crédito otorgado, el que corresponde al indicador porcentual que incluye los intereses y costos de un crédito expresados en un año, y permite comparar con otras formas de financiamiento del mercado.<br />

                            Si el comprador paga en forma anticipada, esto es antes de su fecha de vencimiento, y en una misma oportunidad, la o las cuotas que resten del precio de la presente compraventa, Entel podrá aplicar un descuento sobre el monto total de las cuotas pendientes. La aplicación de dicho descuento y su monto será informado al comprador al momento en que este proponga a Entel el pago anticipado ya referido.<br />

                            El no pago de cualquiera de las cuotas mensuales referidas en la cláusula anterior, faculta a “Entel” a ejercer los derechos y acciones que le otorga la normativa aplicable, incluyendo las siguientes: 1) hacer exigible anticipadamente el pago de todas las cuotas adeudadas restantes como si fueran de plazo vencido; y, 2) bloquear los equipos y accesorios mientras existan cuotas vencidas impagas, quedando los equipos y accesorios imposibilitados para operar en la red pública telefónica, mientras no se regularice el pago de las cuotas por parte del cliente, según lo dispuesto en la resolución exenta N.°1068, de 2013, que regula el bloqueo de equipos terminales móviles de servicios de telecomunicaciones en situaciones especiales, de la Subsecretaría de Telecomunicaciones.<br />

                            Al comprar el comprador conferirá a “Entel” un mandato mercantil para que, en su nombre y representación suscriba un pagaré a la orden de Entel, en los términos dispuestos en el Contrato de Compraventa de Equipo Telefónico Y/O Accesorios publicado en el sitio web de Entel: <a href='https://www.entel.cl/compraenplazo/' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl/compraenplazo/</a><br />

                            Precios Publicados<br />
                            Los precios y servicios ofrecidos en entel.cl y Canales Digitales, sólo tienen aplicación para las compras realizadas por el mismo sitio web y canales digitales y no son aplicables a transacciones efectuadas por otros canales en que Entel comercializa sus productos. De la misma forma, los precios y productos ofrecidos por otros canales no necesariamente tendrán aplicación en las transacciones efectuadas por medio de entel.cl y Canales Digitales.<br />

                            Entel no vende ni da en arrendamiento equipos a $0.- ni a precios extremadamente bajos que impliquen un descuento mayor al 50% del valor inmediatamente anterior publicado por Entel para los mismos equipos o en relación al precio corriente de los mismos. Si el contratante ve este tipo de precios publicados, debe considerar que existe un error involuntario de Entel y abstenerse de contratar pues, en tal caso, la compraventa o el contrato se encuentra viciada en el precio que es uno de sus elementos esenciales en la contratación.<br />

                            En las compras que realice el contratante mediante el uso de tarjetas de crédito, el comprador deberá considerar e informarse previamente de las condiciones de dichos medios de pago directamente con el Banco a través del cual las haya contratado y las ofrecidas por tales medios de pago. Tales condiciones y su aplicación no dependen de Entel.<br />

                            Medios de Pago<br />
                            Entel.cl dispone a sus clientes distintos medios de pago disponibles para efectuar sus compras y/o pago de servicios en entel.cl y Canales Digitales, cuya ejecución y almacenamiento de la información correspondiente es realizada a través de proveedores externos seguros: Transbank Webpay y Bancos Emisores.<br />

                            Entel declara que no almacena en sus sistemas y plataformas los datos de las tarjetas de crédito, débito ni credenciales de accesos a bancos de sus clientes.<br />

                            Los cobros de servicios y algunos productos podrían realizarse a través de la boleta de servicios móviles del cliente que es emitida de forma mensual.<br />

                            Para algunas formas de pago, el emisor puede realizar ciertos cargos, como intereses u otros, relacionados con el procesamiento de la forma de pago seleccionada. Consulte con el emisor de su forma de pago para obtener dicha información. La operación y transacciones realizadas a través de Transbank, Webpay, Bancos e instituciones financieras en general son de su exclusiva responsabilidad.<br />

                            Revisa los medios de pago disponibles aquí.<br />

                            Despacho de los productos<br />
                            El usuario podrá seleccionar el método de despacho y entrega de productos entre los que sean informados al momento de realizar la compra.<br />

                            Es de exclusiva responsabilidad del usuario, asegurar que la información de la dirección de despacho ingresada sea la correcta. En caso de error en el envío de los datos, el usuario podrá comunicarse al 103 o desde cualquier teléfono red fija al número 600 3600 103, con hasta 24 horas de anticipación de la fecha de despacho seleccionada. Si la rectificación es relativa a la dirección, la nueva deberá encontrarse dentro de la comuna originalmente ingresada. De lo contrario, Entel se encontrará facultado para anular la transacción o reagendar la fecha de despacho previa coordinación con el usuario. Los errores en los datos personales motivarán la anulación de la contratación.<br />

                            Entel dispone a sus clientes dos métodos de Despacho a domicilio: Despacho Programado y Despacho Express.<br />

                            Despacho Programado<br />
                            Disponible en compras en entel.cl y canales digitales para solicitar despacho del pedido a la dirección que quieras, siempre y cuando ésta se encuentre habilitada en el formulario de direcciones. El Despacho programado, permite al usuario agendar un día para la entrega con horario de entrega entre las 9.00 y las 18.00 hrs.<br />

                            El servicio de Despacho programado tiene un costo asociado de $2.990, aplicándose un descuento de atención para el usuario, de manera que el costo final a cancelar por este concepto es de $0 al momento de la compra. Entel podrá eliminar o modificar este descuento.<br />

                            Despacho Express<br />
                            Disponible en compras en entel.cl y canales digitales para solicitar despacho de tu pedido dentro de 2 horas a la dirección que indiques, siempre y cuando se tenga cobertura para el despacho Express en la dirección seleccionada.<br />

                            El servicio de Despacho Express tiene un costo asociado de $6.990, aplicándose un descuento de atención para el usuario de manera que el costo final a cancelar por este concepto es de $0 al momento de la compra. Entel podrá eliminar o modificar este descuento.<br />

                            Retiro en Tienda<br />
                            Disponible en compras en entel.cl y canales digitales para retirar tu pedido en la tienda que quieras, siempre y cuando ésta se encuentre habilitada e informada para realizar este proceso y en el horario de atención que se indica para cada tienda. Los productos disponibles para esta modalidad estarán indicados con un ícono en su ficha respectiva y en la selección del método de entrega. Una vez elegida una Tienda de retiro no podrá modificarse con posterioridad.<br />

                            Los productos para Retiro en Tienda quedarán a disposición del cliente durante un plazo máximo de 7 días corridos desde el momento de la compra.<br />

                            Si el producto no fuese retirado dentro del plazo especificado, la transacción quedará sin efecto, iniciándose, si aplica, el proceso de generación de Nota de Crédito por el total de la cantidad pagada.<br />

                            Para efectuar el retiro de tus productos deberás portar tu cédula de identidad y asistir dentro del horario de funcionamiento de la sucursal Entel seleccionada. Recomendamos agendar tu horario de retiro en la pantalla de éxito de la compra.<br />

                            El producto no podrá ser retirado por menores de 18 años, aunque estuviesen autorizados en el flujo de compra.<br />

                            El servicio de Retiro en Tienda no tiene un costo asociado para el usuario.<br />

                            Derecho a Retracto<br />
                            I. El cliente podrá ejercer su derecho a retracto respecto de equipos de telefonía móvil, hogar y accesorios que hayan sido comprados por medios electrónicos, digitales o a distancia, como por ejemplo, a través del sitio web de Entel (<a href='https://www.entel.cl' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl</a>), y atención telefónica o Callcenter, entre otros, dentro de los 10 días siguientes a la fecha de recepción del producto.<br />

                            Para ejercer el derecho a retracto el cliente podrá:<br />

                            <UnorderedList pl='5'>
                                <ListItem>Acudir a una Tienda Entel, presentando boleta/factura de compra o cualquier otro documento que sirva para la acreditación de esta.</ListItem>
                                <ListItem>Solicitarlo en https://ayuda.entel.cl/.</ListItem>
                                <ListItem>Llamando al 103 o desde cualquier teléfono red fija al número 600 3600 103.</ListItem>
                            </UnorderedList>

                            El producto debe entregarse en buen estado, con todos los elementos originales del embalaje, incluyendo sus accesorios, manuales de uso, empaque original y sin uso más allá del necesario para la inspección del producto.<br />

                            No procede el derecho a retracto respecto de:<br />
                            
                            <UnorderedList pl='5'>
                                <ListItem>Servicios: En el caso de los servicios de telecomunicaciones, y conforme el Reglamento que los regula, el suscriptor puede poner término al contrato de suministro de cualesquiera de dichos servicios, en todo momento, notificando de ello a ENTEL, y esta deberá poner término a la provisión del servicio dentro del plazo de 1 día hábil a contar del requerimiento. Para conocer cómo solicitar el término de tus servicios de telecomunicaciones dirígete a <a href='https://www.entel.cl/ley-del-consumidor' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl/ley-del-consumidor</a>.</ListItem>
                                <ListItem>Accesorios de uso personal tales como relojes y audífonos, los que no son aptos para ser devueltos debido a razones de protección de la salud o higiene.</ListItem>
                                <ListItem>Láminas protectoras que se hayan instalado en equipos o accesorios, ya que estos no pueden ser removidos sin su total deterioro.</ListItem>
                                <ListItem>En cualquier caso, cuando el producto o accesorio se haya deteriorado por hechos imputables al usuario.</ListItem>
                                <ListItem>Los bienes que por su naturaleza no pueden ser devueltos. Corresponden a aquellos que no pueden volver a comercializarse en las condiciones ofrecidas originalmente, por haberse instalado o utilizado más allá de su inspección, como es el caso de un equipo tipo Tablet utilizado más allá de su inspección.</ListItem>
                            </UnorderedList>
                            
                            Término del contrato de servicio de telecomunicaciones<br />
                            El cliente podrá poner término al contrato en cualquier momento, llamando desde su móvil Entel al 103 o desde cualquier teléfono red fija al número 600 3600 103 o a través de los medios adicionales que Entel disponga, los que serán informados a través del sitio <a href='https://www.entel.cl' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl</a> en este enlace: ver aquí.<br />

                            Garantías<br />
                            Garantía legal de nuestros Equipos y Accesorios<br />
                            Todo Equipo o Accesorio adquirido en entel.cl o canales digitales cuenta con la garantía legal regulada en la Ley N°19.496 sobre protección de los derechos de los consumidores ("LPDC”). Conforme a lo anterior, si el Equipo presenta deficiencias de aquellas descritas en el artículo 20 de la LPDC, a contar del 24 de marzo de 2022(*), el consumidor tendrá un plazo de 6 meses desde la compra o recepción para elegir alguna de las siguientes opciones:<br />

                            <UnorderedList pl='5'>
                                <ListItem>Cambios de producto; previa devolución del producto deficiente.</ListItem>
                                <ListItem>Devolución del dinero, previa restitución del producto deficiente.</ListItem>
                                <ListItem>Reparación del producto.</ListItem>
                                <ListItem>De proceder, derecho a indemnización de perjuicios.</ListItem>
                            </UnorderedList>
                            (*) Hasta el 23 de marzo de 2022, el plazo de garantía legal es 3 meses desde la compra o recepción.<br />

                            Garantías convencionales de nuestros Equipos<br />
                            Para Equipos nuevos Entel ofrece una garantía convencional que cubre todas las fallas de fabricación validadas por laboratorio de servicio técnico de Entel, desde el término de la Garantía legal y hasta los 12 meses posteriores a la compra del equipo. La solución entregada considera la reparación sin costo o reemplazo del equipo por uno reacondicionado según lo que determine el fabricante.<br />

                            Para Equipos reacondicionados la garantía convencional cubre todas las fallas de fabricación validadas por laboratorio de servicio técnico de Entel hasta los 12 meses posteriores a la compra del equipo.<br />

                            Para más información, visita https://ayuda.entel.cl.<br />

                            El ejercicio de este derecho se encuentra sujeto a la determinación del Servicio Técnico para resolver sobre la procedencia del desperfecto, para lo cual se deben cumplir con los siguientes requisitos:<br />

                            <UnorderedList pl='5'>
                                <ListItem>El producto debe haber sido comercializado por Entel.</ListItem>
                                <ListItem>El producto debe encontrarse dentro del plazo de la garantía (6 meses para acceder a la garantía legal y del mes 6 al 12 para la garantía voluntaria).</ListItem>
                                <ListItem>El equipo debe ser ingresado en una tienda Entel con atención de servicio técnico.</ListItem>
                                <ListItem>El equipo debe presentar una falla de fabricación validada por el servicio técnico de Entel.</ListItem>
                                <ListItem>Debe acompañarse copia de la boleta, factura u otro documento que acredite la compra.</ListItem>
                            </UnorderedList>

                            No será procedente la garantía legal ni la voluntaria en los siguientes casos:

                            <UnorderedList pl='5'>
                                <ListItem>Daños causados por golpes, caídas, transporte y bodegaje inadecuado o trato incorrecto, como también los daños por desastres naturales, ya sean a causa de temblor, terremoto, maremoto, inundaciones, anegaciones, relámpagos, humedad y/o presencia de líquido en el interior del producto, ambientes de polvo excesivos, entre otros.</ListItem>
                                <ListItem>La manipulación del producto en condiciones no prescritas en el manual de usuario. Componentes internos o externos quebrados.</ListItem>
                                <ListItem>Si el producto fue intervenido por un tercero, no autorizado por el fabricante.</ListItem>
                                <ListItem>Si el producto presenta manipulación y/o alteración del software.</ListItem>
                                <ListItem>Si la serie del producto se encuentra borrada o ilegible.</ListItem>
                                <ListItem>Si los sellos de garantía se encuentran rotos o alterados.</ListItem>
                                <ListItem>Uso impropio, distinto del uso doméstico o del indicado en el manual de usuario y/o en condiciones ambientales.</ListItem>
                                <ListItem>Defectos técnicos derivados de problemas en la instalación incorrecta del producto.</ListItem>
                                <ListItem>Uso de productos, equipos, sistemas, repuestos, accesorios, aplicaciones, conexiones externas, instalaciones o conectores no suministrados ni recomendados en el manual de usuario.</ListItem>
                                <ListItem>Por rotura de la pantalla por golpe o mal uso.</ListItem>
                            </UnorderedList>

                            Tratamiento de datos personales<br />
                            El cliente autoriza expresamente en este acto a Entel a realizar el tratamiento de sus datos personales, en los términos señalados en su política de privacidad de clientes entel ubicada en el siguiente link: <a href='https://www.entel.cl/legales/' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl/legales/</a> la que se entiende formar parte integrante del presente contrato para todos los efectos legales, declarando el cliente conocerla y aceptarla, facultando a Entel para tratar sus datos personales, incluyendo la solicitud, recolección, almacenamiento y en general a realizar el tratamiento sobre los siguientes datos personales: (a) nombre; (b) cédula de identidad; (c) domicilio; (d) correo electrónico; (e) número de teléfono; (f) imagen; (g) voz; (h) datos biométricos; (i) datos de geolocalización; (j) hábitos de consumo, solo y únicamente y en la medida que sea necesario para la prestación de los servicios objeto del presente contrato y sus anexos.<br />

                            Además de las finalidades de la propia prestación de los servicios, el cliente autoriza expresamente a entel para realizar el tratamiento de sus datos personales, solo y únicamente para: (a) el envío de comunicaciones comerciales, promocionales o publicitarias, pudiendo el cliente siempre y en cualquier momento suspenderlas a través de los canales que para ello disponga entel, (b) para el mejoramiento de las experiencias de consumo únicamente en la forma descrita en su política de privacidad y (c) para los fines expresamente señalados en la política ya referida.<br />

                            Asimismo, el cliente declara conocer y autoriza que entel pueda transmitir o comunicar sus datos personales a terceros relacionados o no, ya sea en forma nacional o transfronteriza solo y únicamente para el cumplimiento de los fines señalados en este contrato. Los estándares de seguridad para la transmisión nacional y transfronteriza de los datos personales están señalados en el documento denominado política corporativa de seguridad de la información<br />

                            El tratamiento de los datos personales del cliente y el ejercicio de sus derechos de acceso, rectificación, cancelación u oposición, están sometidos a la ley n° 19.628 y el cliente podrá dirigirse a los canales dispuestos por entel en su política para dichos efectos.<br />

                            Medios de contacto<br />
                            Toda presentación o reclamo relacionado con actos o contratos ejecutados o celebrados a través de entel.cl o canales digitales, pueden ser presentados a través de:<br />

                            <UnorderedList pl='5'>
                                <ListItem>Call Center, llamando al 105 desde un móvil Entel o al 600 3700 105 desde teléfonos red fija.</ListItem>
                                <ListItem>Mi Entel.</ListItem>
                            </UnorderedList>

                            Para más información sobre ingreso de reclamos y canales de contacto con Entel, entrar aquí.<br />

                            Supletoriedad de Contrato<br />
                            En todo lo no regulado en el presente documento, regirán las normas legales y disposiciones normativas que sean aplicables y lo convenido en el Contrato respectivo y sus anexos.<br />

                            Jurisdicción<br />
                            El cliente podrá acudir siempre ante el tribunal competente conforme a las disposiciones establecidas en la Ley N°19.496, que establece normas sobre protección de los derechos de los consumidores. Sólo una vez surgido el conflicto, las partes podrán someterlo a mediación, conciliación o arbitraje. Si estuvieren disponibles estas opciones, Entel informará la naturaleza de cada uno de los mecanismos ofrecidos, los cuales serán gratuitos y sólo se iniciarán por voluntad expresa del cliente, la que deberá constar por escrito. Lo anterior de conformidad con lo que disponga el correspondiente reglamento dictado por el Ministerio de Economía, Fomento y Turismo. Adicionalmente, Entel podrá adscribir y ofrecer libremente el sistema de solución de controversias dispuesto en los artículos 56 A y siguientes de la Ley ya referida. Este sistema podrá llevarse a cabo por medios electrónicos. Más información sobre atención al Cliente y resolución de controversias en <a href='https://www.entel.cl' target='_blank' style={{ color: '#002EFF' }}>www.entel.cl</a>.<br />

                            Vigencia<br />
                            Los presentes Términos y Condiciones se mantendrán vigentes desde su publicación en el sitio web de Entel y mientras no sean modificados por otro instrumento que será debidamente informado por Entel en este mismo sitio web.<br />
                        </Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button bg='#002EFF' color="white" w='90%' mx='auto' py='6' borderRadius="30px" onClick={onCloseTerms} _hover={{ bg: '#001bb3' }}>
                            Entendido
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Modal Comunicaciones comerciales */}
            <Modal isOpen={isOpenComunicaciones} onClose={onCloseComunicaciones} isCentered size="2xl" scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent borderRadius="15px" maxH="90vh">
                    <ModalHeader className='Subtitle' fontWeight='0' fontSize='2xl'>Detalle consentimiento comunicaciones comerciales</ModalHeader>
                    <ModalCloseButton color="black" />
                    <ModalBody py="6">
                        <Box as="ul" pl='5' className='General' sx={{ listStyleType: 'disc', '& > li': { marginBottom: '1rem' } }}>
                            <li>Acepto recibir comunicaciones comerciales personalizadas de Entel basadas en los datos que se están entregando, datos de navegación en los sitios e interacciones con Entel.</li>
                            <li>Acepto recibir comunicaciones comerciales personalizadas de Entel basadas en datos de localización. Trataremos este dato hasta un plazo de 5 años.</li>
                            <li>Acepto recibir comunicaciones comerciales de Entel sobre terceros con los que tenga acuerdos.</li>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button bg='#002EFF' color="white" w='90%' mx='auto' py='6' borderRadius="30px" onClick={onCloseComunicaciones} _hover={{ bg: '#001bb3' }}>
                            Entendido
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
};

export default SlideModal;